import { ExportDownloadLinkCell } from 'components/cells/ExportDownloadLinkCell';
import { ExportStatusCell } from 'components/cells/ExportStatusCell';
import { LogActionIcon } from 'components/icons/Logs/LogActionIcon';

export const columnsDataRecentActivityLog = [
	{
		Header: 'Usuário',
		accessor: 'usuario',
		type: 'text',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Descrição da Atividade',
		accessor: 'descricaoAtividade',
		disableSortBy: true,
		type: 'iconText',
		jsx: LogActionIcon,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Data',
		accessor: 'data',
		type: 'date',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Tempo da Atividade',
		accessor: 'tempoAtividade',
		type: 'text',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Status',
		accessor: 'status',
		type: 'iconText',
		jsx: ExportStatusCell,
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Link do Arquivo',
		accessor: 'linkArquivo',
		type: 'iconText',
		jsx: ExportDownloadLinkCell,
		optional: true,
		disableSortBy: true,
	},
];
